import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from '../../components/Common/ApiManagement/apiServices';
import { handleErrors, showToaster } from "components/Common/common";
import { Link, useNavigate } from "react-router-dom";
import { PAGEPATHS } from "components/Common/Constant";


const ActivationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();


  const code = location.search.split('?')[1];

  useEffect(() => {
    if (code) {
      const sendData = async () => {
        try {
          const postForm = {
            activationCode: code
          }
          const { data } = await axiosInstance.post(ApiNames.USER_ACTIVATION, postForm);

          if (data.status === 0) {
            showToaster(data.status, data.message)
          }
          if (data.status === 1) {
            showToaster(data.status, data.message)
            navigate(PAGEPATHS.Login);
          }
        } catch (error) {
          handleErrors(error)
        }
      };

      sendData();
    }
  }, [code]);

  return (
    <div>
      <h2>Activating your account...</h2>
    </div>
  );
};

export default ActivationPage;
